/**
 * Drobiazgi jezykowe do tekstow interfejsu. Czyste funkcje, zero zaleznosci.
 */

/**
 * Polski rzeczownik po liczbie: 1 - jeden, 2-4 (poza 12-14) - kilka, reszta - wiele.
 *
 * Liczba NIECALKOWITA (np. srednia 17,5) bierze dopelniacz liczby pojedynczej: "17,5 slowa",
 * a nie "17,5 slow". Domyslnie to ta sama forma co `kilka`, co zgadza sie dla slowa, proby,
 * wypowiedzi; rzeczownik, dla ktorego sie nie zgadza (np. "token" - "2 tokeny", ale "2,5 tokenu"),
 * podaje ja jawnie w `ulamek`.
 */
export function odmien(n: number, jeden: string, kilka: string, wiele: string, ulamek: string = kilka): string {
  if (!Number.isInteger(n)) return ulamek;
  if (n === 1) return jeden;
  const reszta10 = n % 10;
  const reszta100 = n % 100;
  if (reszta10 >= 2 && reszta10 <= 4 && !(reszta100 >= 12 && reszta100 <= 14)) return kilka;
  return wiele;
}
